export default "__VITE_ASSET__DuqJEXlR__"